module.exports = __webpack_public_path__ + "static/media/garzon.b22c9e2e.svg";